var exports = {
  "k": "x93eb46d8--d1e929--container",
};

module.exports = exports;
